import axios from 'axios'
import Vue from 'vue'

const state = {
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  credentials: localStorage.getItem('credentials')
    ? JSON.parse(localStorage.getItem('credentials'))
    : null,
}

const getters = {
  user: state => state.user,
  credentials: state => state.credentials,
  apiAccessToken: state => {
    return state.credentials !== null && state.credentials.api_access_token !== null
      ? state.credentials.api_access_token
      : null
  },
  isLogged: state => state.user != null,
  isAuthenticated: state => {
    return (
      state.credentials !== null &&
      state.credentials.api_expiry_time !== null &&
      state.credentials.api_expiry_time > Math.floor(Date.now() / 1000)
    )
  },
}

const mutations = {
  setUser: (state, user) => {
    state.user = user
    localStorage.setItem('user', JSON.stringify(state.user))
  },
  setIdToken: (state, token) => {
    state.id_token = token
    localStorage.setItem('id_token', token)
  },
  setCredentials: (state, credentials) => {
    state.credentials = credentials
    localStorage.setItem('credentials', JSON.stringify(state.credentials))
  },
  removeUser: state => {
    state.user = null
    state.credentials = null
    localStorage.removeItem('user')
    localStorage.removeItem('credentials')
  },
}

const actions = {
  setCurrentUser: ({ commit }, user) => {
    commit('setUser', user)
  },
  setCurrentCredentials: ({ commit }, credentials) => {
    commit('setCredentials', credentials)
  },
  refreshAccessTokens: async ({ commit }) => {
    const userEmail = { email: state.user.email }
    const response = await axios.post(`${Vue.prototype.$baseURL}/signin/verify/token`, {
      ...userEmail,
      ...state.credentials,
    })
    const credentials = response.data.credentials
    await commit('setCredentials', credentials)
  },
  removeCurrentUser: ({ commit }) => {
    commit('removeUser')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
